import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// assets
import LogoImage from '../../../assets/logo-full.png';
// components
import Image from './Image';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink, sx }) {
  const logo = (
    <Box sx={{ width: 140, height: 'auto', lineHeight: 0, ...sx }}>
      <Image src={LogoImage} alt="Crewpass" sx={{ width: 1, height: 'auto' }} />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
